import {
  GET_MEMBER_LIST_SUCCESS,
  INVITE_ORG_MEMBERS_SUCCESS,
  REMOVE_ORG_USER_SUCCESS,
  UPDATE_ORG_MEMBER_ROLE_REQUEST,
  UPDATE_ORG_MEMBER_ROLE_SUCCESS,
  GET_ORG_SUCCESS,
} from '../constants';
import { createReducer } from './Utils';
import { FunctionMap, OrgState } from '../../types';
import { SetOrg, FSAInterface } from '../actions';
import Org, { OrgMember } from '../../models/Org';
import uniqBy from 'lodash/fp/uniqBy';

function setMembers(state: OrgState, action: any) {
  return { ...state, members: action.payload };
}

function setMemberRoleOptimistic(state: OrgState, action: any) {
  const { payload } = action;
  const newMembers = state.members.map((member: OrgMember) => {
    if (member._id === payload.memberId) {
      return { ...member, role: payload.role };
    }

    return member;
  });
  return { ...state, members: newMembers };
}

function setMemberRole(state: OrgState, action: any) {
  const { payload } = action;
  const updatedId = Object.keys(payload.members)[0];
  const updatedMember = payload.members[updatedId];
  const { members } = state;
  const newMembers = members.map((member: OrgMember) => {
    if (member._id === updatedId) {
      return { ...member, role: updatedMember.role };
    }

    return member;
  });

  return { ...state, members: newMembers };
}

function removeOrgUser(state: OrgState, action: any) {
  const { members } = state;
  const newMembers = members.filter((member: OrgMember) => member._id !== action.payload._id);
  return { ...state, members: newMembers };
}

function addNewMembers(state: OrgState, action: any) {
  const invitedMembers = action.members;
  // Need to bail if success array is empty, the api could return no successful invites.
  if (!invitedMembers.length) {
    return { ...state };
  }
  const { members } = state;
  const newMembers = uniqBy('_id', [...members, ...invitedMembers]);
  return { ...state, members: newMembers };
}

function setOrg(state: OrgState, action: FSAInterface<SetOrg['payload']>) {
  const { _id, name, createdDate, isEnterprise, paymentAttempt, billingStatus, metadata, api, oauth } =
    action.payload as Org;
  return { ...state, _id, name, createdDate, isEnterprise, paymentAttempt, billingStatus, metadata, api, oauth };
}

const functionMap: FunctionMap = {
  [GET_MEMBER_LIST_SUCCESS]: setMembers,
  [UPDATE_ORG_MEMBER_ROLE_REQUEST]: setMemberRoleOptimistic,
  [UPDATE_ORG_MEMBER_ROLE_SUCCESS]: setMemberRole,
  [REMOVE_ORG_USER_SUCCESS]: removeOrgUser,
  [INVITE_ORG_MEMBERS_SUCCESS]: addNewMembers,
  [GET_ORG_SUCCESS]: setOrg,
};

export default createReducer(functionMap, { members: [] });
